export default __webpack_public_path__ + "static/media/ceo.caf6ce76.png";